import React from 'react';
import PhoneInputLib from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

export const PhoneInput = ({ value, onChange, className = '', ...props }) => {
  return (
    <div className={`phone-input-wrapper ${className}`} data-testid={props['data-testid'] || 'phone-input'}>
      <PhoneInputLib
        international
        defaultCountry="FR"
        value={value}
        onChange={onChange}
        className="phone-input-field"
        {...props}
      />
      <style>{`
        .phone-input-wrapper .PhoneInput {
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .phone-input-wrapper .PhoneInputCountry {
          display: flex;
          align-items: center;
          padding: 0 4px;
        }
        .phone-input-wrapper .PhoneInputCountryIcon {
          width: 24px;
          height: 18px;
          border-radius: 2px;
          overflow: hidden;
        }
        .phone-input-wrapper .PhoneInputCountryIcon--border {
          box-shadow: 0 0 0 1px rgba(0,0,0,0.1);
        }
        .phone-input-wrapper .PhoneInputCountrySelect {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          z-index: 1;
          border: 0;
          opacity: 0;
          cursor: pointer;
        }
        .phone-input-wrapper .PhoneInputCountrySelectArrow {
          display: block;
          width: 6px;
          height: 6px;
          border-style: solid;
          border-color: hsl(var(--muted-foreground));
          border-top-width: 0;
          border-bottom-width: 1.5px;
          border-left-width: 0;
          border-right-width: 1.5px;
          transform: rotate(45deg);
          margin-left: 4px;
        }
        .phone-input-wrapper .PhoneInputInput {
          flex: 1;
          height: 36px;
          padding: 0 12px;
          border-radius: calc(var(--radius) - 2px);
          border: 1px solid hsl(var(--input));
          background: hsl(var(--background));
          font-size: 14px;
          color: hsl(var(--foreground));
          outline: none;
          transition: border-color 0.15s, box-shadow 0.15s;
        }
        .phone-input-wrapper .PhoneInputInput:focus {
          border-color: hsl(var(--primary));
          box-shadow: 0 0 0 2px hsl(var(--primary) / 0.2);
        }
        .phone-input-wrapper .PhoneInputInput::placeholder {
          color: hsl(var(--muted-foreground));
        }
      `}</style>
    </div>
  );
};
